'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$29() {
  this.bhw = null;
  this.bhu = null;
  this.bhv = false;
  this.bhs = null;
  this.bht = false;
  this.bhx = false;
  this.bhy = false;
  this.bhw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$29 as $c_Lpresto_PrestoRouter$$anon$29 };
$p = $c_Lpresto_PrestoRouter$$anon$29.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$29;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$29() {
}
export { $h_Lpresto_PrestoRouter$$anon$29 as $h_Lpresto_PrestoRouter$$anon$29 };
$h_Lpresto_PrestoRouter$$anon$29.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bhw;
});
$p.t = (function() {
  if ((!this.bhv)) {
    this.bhu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhv = true;
  }
  return this.bhu;
});
$p.ag = (function() {
  if ((!this.bht)) {
    this.bhs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bht = true;
  }
  return this.bhs;
});
$p.v = (function() {
  if ((!this.bhy)) {
    this.bhx = false;
    this.bhy = true;
  }
  return this.bhx;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$29 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$29, "presto.PrestoRouter$$anon$29", ({
  O2: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$29 as $d_Lpresto_PrestoRouter$$anon$29 };
//# sourceMappingURL=presto.-Presto-Router$$anon$29.js.map
